// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25fLV","largestCol":"styles_largestCol__2niT8","smallestCol":"styles_smallestCol__1Irzc"};